import { createContext, useContext, useState } from "react";
import { noop } from "lodash";
import type { TabProps } from "@circle-react-uikit/Tabs/Tab";
import type { TabNavigationViewProps } from "./TabNavigationView";
import { TabNavigationView } from "./TabNavigationView";

export interface TabNavigationProps extends TabNavigationViewProps {
  children: React.ReactNode;
  initialTab?: string;
}

export interface TabNavigationContext {
  currentTab?: string;
  setCurrentTab?: (tab: string) => void;
  tabs: Array<TabProps>;
}

const TabNaVigationData = createContext<TabNavigationContext>({
  tabs: [],
  currentTab: "",
  setCurrentTab: noop,
});
TabNaVigationData.displayName = "TabNaVigationData";

export const useTabNavigation = () => useContext(TabNaVigationData);

/** @deprecated Please use the new Tab at "@circle-react-uikit/TabV2" */
export const TabNavigation = ({
  children,
  initialTab = "",
  tabs = [],
  ...rest
}: TabNavigationProps) => {
  const [currentTab, setCurrentTab] = useState(
    initialTab || tabs[0]?.label || "",
  );

  return (
    <TabNaVigationData.Provider
      value={{
        tabs,
        currentTab,
        setCurrentTab,
      }}
    >
      <div className="flex size-full flex-col">
        <TabNavigationView
          {...rest}
          tabs={tabs}
          currentTab={currentTab}
          onTabClick={(tab: string) => setCurrentTab(tab)}
        />
        <div className="flex-1">{children}</div>
      </div>
    </TabNaVigationData.Provider>
  );
};
